module.exports = __webpack_public_path__ + "static/media/wcgSeating.a13f73b1.jpg";